module.exports = __webpack_public_path__ + "static/hero-together-64b801ac366b71b78c9e4832753c48b6.jpg";